import * as React from 'react';

import { useBoolean, useLockFn } from 'ahooks';
import { Button, Divider, Form, Modal, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { CheckOutlinedIcon, DeleteOutlinedIcon } from 'components';
import { useCatalogValue } from 'context';
import { deleteCatalog } from 'services';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    CATALOGS: { BASE_URL: CATALOGS_BASE_URL },
  },
} = PATHNAME;

const CatalogFormAction = () => {
  const [deleteModalInstance, deleteModalContextHolder] = Modal.useModal();
  const [deleteLoading, { toggle: toggleDeleteLoading }] = useBoolean();
  const { id, mode } = useCatalogValue();
  const navigate = useNavigate();

  const handleDeleteCatalog = useLockFn(
    async ({
      id,
    }: Pick<Required<ReturnType<typeof useCatalogValue>>, 'id'>) => {
      toggleDeleteLoading();

      deleteCatalog({ id })
        .then(() => {
          navigate(CATALOGS_BASE_URL);
          notification.success({
            message: 'کاتالوگ با موفقیت حذف شد.',
          });
        })
        .catch(message => {
          notification.error({
            message,
          });
        })
        .finally(() => {
          toggleDeleteLoading();
        });
    },
  );

  return (
    <div>
      <div className='px-6 pt-4'>
        <Typography.Title level={3} className='mb-0 text-base font-medium'>
          انتشار کاتالوگ
        </Typography.Title>
      </div>

      <Divider className='mb-8 mt-4' />

      <div className='px-6'>
        <Typography.Paragraph>
          از طریق این بخش می‌توانید کاتالوگ ساخته شده و یا ویرایش شده را منتشر
          کنید.
        </Typography.Paragraph>
      </div>

      <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
        {mode === 'Update' ? (
          <Form.Item>
            <Button
              block
              danger
              className='flex items-center'
              icon={<DeleteOutlinedIcon />}
              loading={deleteLoading}
              onClick={async () => {
                const confirmed = await deleteModalInstance.confirm({
                  title: 'آیا از حذف این کاتالوگ اطمینان دارید؟',
                  width: 500,
                });
                if (id && confirmed) {
                  handleDeleteCatalog({ id });
                }
              }}
            >
              <span>حذف کاتالوگ</span>
            </Button>
            {deleteModalContextHolder}
          </Form.Item>
        ) : null}

        <Form.Item>
          <Button
            block
            type='primary'
            htmlType='submit'
            icon={<CheckOutlinedIcon />}
          >
            {mode === 'Create' ? (
              <span>افزودن کاتالوگ جدید</span>
            ) : (
              <span>ذخیره تغییرات</span>
            )}
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export { CatalogFormAction };
